/**
 * PURPOSE:
 * Helpers visuales de cancha para el visualizador público de vóley.
 *
 * ROUTE:
 * src/pages/VolleyballViewer/utils/volleyballViewerCourt.js
 */

export const LEFT_COURT_LAYOUT = [
  [5, 4],
  [6, 3],
  [1, 2],
];

export const RIGHT_COURT_LAYOUT = [
  [2, 1],
  [3, 6],
  [4, 5],
];

const POSITION_ROMAN = {
  1: "I",
  2: "II",
  3: "III",
  4: "IV",
  5: "V",
  6: "VI",
};

export function romanPosition(position) {
  return POSITION_ROMAN[Number(position)] || String(position || "—");
}

export function byPosition(players = []) {
  const map = new Map();
  for (const row of Array.isArray(players) ? players : []) {
    map.set(Number(row.position), row);
  }
  return map;
}

export function teamLabel(team) {
  return team?.abrev || team?.name || "Equipo";
}
